<template>
  <div class="footer">
    <div class="footer-main">
      <p>©BYTEPLAY GAMES LIMITED ALL RIGHTS RESERVED.</p>
      <p><router-link target="_blank" v-if="data.privacy" :to="data.url">{{data.privacy}}</router-link> </p>
    </div>
  </div>
</template>

<script>
  export default{
    data(){
      return{
        data:''
      }
    },
    props: {
        resData: {
        }
    },
    watch: {
        resData(newData){
            this.data=newData;
        }
    },
  }
</script>

<style scoped>
  .footer{
    padding-top: 98px;
    height: 190px;
    background: url('~@/assets/images/footer-bg1.png') right no-repeat, url('~@/assets/images/footer-bg2.png') left no-repeat,#F7F7F7;
    background-size: auto 100%;
    box-sizing: border-box;
  }
  .footer-main{
    display: block;
    height: 100%;
    width: 100%;
    background-color: #333;
    text-align: center;
    box-sizing: border-box;
    padding-top: 20px;
  }
  .footer-main p,.footer-main p a{
    color: white;
    font-size: 18px;
  }
  .footer-main p:nth-of-type(2){
    cursor: pointer;
    margin-top: 10px;
  }
  @media screen and (max-width: 1000px){
    .footer-main p{
      color: white;
      font-size: 16px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/footer.vue